// A status is a glyph and a word in mono (`● new`, `◐ regressed`); a kind is a coloured mono
// word (`crash`, `hang`). Never a coloured pill: pills are for values (Pill). The glyph is
// decoration, so a screen reader hears the word only.
import { useUiText } from '../text'

export type StatusKey = 'new' | 'reg' | 'on' | 'res' | 'fire' | 'miss' | 'mute' | 'ok'

/** The glyph alone, for a row that shows the status without its word (Find). */
export const STATUS_GLYPH: Record<StatusKey, string> = {
  new: '●',
  reg: '◐',
  on: '○',
  res: '✓',
  fire: '●',
  miss: '!',
  mute: '○',
  ok: '✓',
}

/**
 * `● new`; `label` replaces the word (it stays in the status's colour), `glyph` the glyph (a
 * closed pull request's `–`).
 */
export function Status({ s, label, glyph }: { s: StatusKey; label?: string; glyph?: string }) {
  const words = useUiText().status
  return (
    <span className={`st ${s}`}>
      <span aria-hidden="true">{glyph ?? STATUS_GLYPH[s]} </span>
      <span>{label ?? words[s]}</span>
    </span>
  )
}

/** An issue's kind as a coloured word. The word is telemetry (crash, hang, anr, network). */
export function Kind({ k, label }: { k: string; label?: string }) {
  return (
    <span className={`kd ${k}`} translate="no">
      {label ?? k}
    </span>
  )
}
